// Placeholder Messenger component
import React from 'react';

const Messenger = () => {
  return (
    <div className="p-6">
      <h1 className="text-lg font-bold mb-4 text-gray-900 dark:text-gray-100">Messenger</h1>
      <p className="text-gray-600 dark:text-gray-300">Student messaging system coming soon...</p>
    </div>
  );
};

export default Messenger;